<template>
  <div
    class="action-card bg-white w-[280px] cursor-pointer border-r border-r-grayNeutral rounded-tl-md"
    :class="{ current: currentMetric === data.slug }"
    @click="$emit('actionClick', data.slug)"
  >
    <div class="p-3">
      <div class="flex items-center gap-2 text-gray-600 mb-2">
        <svg width="16" height="16">
          <use :xlink:href="`#${data.icon}`"></use>
        </svg>

        <el-tooltip placement="top">
          <div slot="content">{{ data.tooltipValue }}</div>
          <span class="action-name font-bold">{{ data.name }}</span>
        </el-tooltip>
      </div>
      <div class="text-2xl font-bold">{{ data.type === 'number' ? numberMetric : percentageMetric }}</div>
      <div v-if="data.diff" :class="`${data.isPositive ? 'text-success' : 'text-danger'} mt-1`">
        {{ data.isPositive ? '+' : '' }}{{ data.diff }}%
      </div>
    </div>
    <div class="active-bar w-full h-[3px]"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: null,
    },
    currentMetric: {
      type: null,
    },
  },
  computed: {
    numberMetric() {
      const value = this.data.metric

      if (value >= 1000) {
        return (value / 1000).toFixed(0) + 'k'
      }
      return value.toString()
    },

    percentageMetric() {
      const value = this.data.metric
      return value
    },
  },
}
</script>
<style lang="scss">
.action-card {
  &:hover,
  &.current {
    .action-name {
      @apply text-primary;
    }
    .active-bar {
      @apply bg-primary;
    }
  }
}
</style>
